const parsed = Number.parseInt(process.env.VDR_BATCH_MAX_FILES, 10);
export const BATCH_MAX_FILES = parsed > 0 ? parsed : 200;
